module.exports = __webpack_public_path__ + "img/1558622.6124204b.svg";